module.exports = __webpack_public_path__ + "img/target-03.6dceb366.svg";